import api from "@/components/customAxios/Axios";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "@/components/toast";

const SendAssessmentLink = ({
	candidateId,
	validity_days,
}: {
	candidateId: string;
	validity_days: string;
}) => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const sendAssessmentMail = async () => {
		try {
			setLoading(true);
			const response = await api.post(`/approve_candidate`, {
				candidate_id: candidateId,
				validity_days: validity_days,
			});
			if (
				response.status === 200
			) {
				window.history.back();
				toast.success({
					duration: 5000,
					status: "success",
					title: "Assessment Link Sent",
					description: "The assessment link has been sent to the candidate successfully.",
					open: true,
				});
			}
		} catch (error: any) {
			toast.error({
				duration: 5000,
				status: "error",
				title: "Error Sending Assessment Link",
				description: error.response?.data?.message || error.response?.data?.error || "Failed to send assessment link. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<button
				onClick={sendAssessmentMail}
				className=" text-[#438437] bg-[#BDE4C3] font-medium hover:scale-110 transition focus:outline-none py-2 px-3 rounded-md"
			>
				Send Assessment Link
			</button>
		</>
	);
};

export default SendAssessmentLink;
